import React from 'react';
import { connect } from 'react-redux';

import CustomHead from '@components/customHead/CustomHead.tsx';
import { StoreT } from '@global/types.ts';

import About from './components/about/About.tsx';
import AppInfo from './components/appInfo/AppInfo.tsx';
import Faq from './components/faq/Faq.tsx';
import FnsInfo from './components/fnsInfo/FnsInfo.tsx';
import Header from './components/header/Header.tsx';

import ExecutorsI from './types.ts';

import Menu from '../menu/Menu.tsx';
import meta from './static/meta.ts';

class Executors
    extends React.Component<ExecutorsI['props'], ExecutorsI['state']>
    implements ExecutorsI
{
    parent: ExecutorsI['parent'];

    constructor(props: ExecutorsI['props']) {
        super(props);
        this.state = {};

        this.parent = React.createRef();
    }

    meta = meta;

    render() {
        const { storePages } = this.props;

        return (
            <div className="public__pageInner _col">
                {!storePages.auth.isShow && (
                    <CustomHead title={this.meta.title} description={this.meta.description} />
                )}
                <div className="public__section">
                    <Header />
                </div>
                <div className="public__section">
                    <About />
                </div>
                <div className="public__section">
                    <AppInfo />
                </div>
                <div className="public__section">
                    <Faq />
                </div>
                <div className="public__section">
                    <FnsInfo />
                </div>
                <div className="public__section _footer">
                    <Menu pageName="executors" isFooter={true} />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: StoreT) {
    return {
        storePages: state.pages,
    };
}

export default connect(mapStateToProps)(Executors);
